import { createRoot } from "react-dom/client";
import "./index.css";
import BreakthroughSection from "./App.jsx";

function initBreakthroughSection() {
  const container = document.getElementById("breakthrough-root");
  if (container) {
    const root = createRoot(container);
    root.render(<BreakthroughSection />);
  } else {
    console.warn("Breakthrough section container #breakthrough-root not found");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBreakthroughSection);
} else {
  initBreakthroughSection();
}
